// istanbul ignore next
export const isMobile = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
};
